/** @format */

import { CommercialConditions, RoomAvailability } from '@/ducks/bookingNew/types';
import { TRoom } from '@/ducks/room/declarations';

export const utilityGetPrice = ({ commercialConditions, availability, room, pdpPage }: UtilityGetPriceParams) => {
  const hasPromo = () => {
    if (commercialConditions?.discountedPrice) return true;
    if (availability?.discountedPrice) return true;
    if (pdpPage) return false;
    return room?.basePrice !== room?.discountedPrice && !!room?.discountedPrice;
  };

  const getDiscountedPrice = () => {
    if (!hasPromo()) return 0;
    if (commercialConditions?.discountedPrice) return commercialConditions.discountedPrice;
    if (availability?.discountedPrice) return availability.discountedPrice;
    if (pdpPage) return 0;
    return room.discountedPrice ?? 0;
  };

  const getBasePrice = () => {
    if (commercialConditions?.price) return commercialConditions.price;
    if (availability?.price) return availability.price;
    if (pdpPage) return 0;
    return room.basePrice;
  };

  const getDiscountedPricePercentage = () => {
    if (!hasPromo()) return 0;

    const discountedPrice = getDiscountedPrice();
    const basePrice = getBasePrice();

    return ((basePrice - discountedPrice) / basePrice) * 100;
  };

  const commercialConditionPrice = commercialConditions?.discountedPrice
    ? commercialConditions?.discountedPrice
    : commercialConditions?.price;

  const availabilityPrice = availability?.discountedPrice ? availability?.discountedPrice : availability?.price;

  const roomPrice = room?.discountedPrice ? room.discountedPrice : room?.basePrice;

  const getFormattedPrice = () => {
    if (!!commercialConditionPrice) return commercialConditionPrice;
    if (!!availabilityPrice) return availabilityPrice;
    if (pdpPage) return 0;
    return roomPrice;
  };

  const getDiscountUntilDate = () => {
    if (!hasPromo()) return '';
    if (commercialConditions?.discountUntil) return commercialConditions.discountUntil;
    if (availability?.discountUntil) return availability.discountUntil;
    if (pdpPage) return '';
    if (room?.discountUntil) return room.discountUntil;
    return null;
    // il  NULL è caso di errore in cui la chiave non viene passata da api';
  };

  const getDimension: 'special_offer' | 'full_price' = hasPromo() ? 'special_offer' : 'full_price';

  const getMetric = hasPromo() ? getBasePrice() - getDiscountedPrice() : 0;

  return {
    getDiscountedPrice,
    getDiscountedPricePercentage,
    getBasePrice,
    hasPromo,
    getFormattedPrice,
    getDiscountUntilDate,
    getMetric,
    getDimension,
  };
};

type UtilityGetPriceParams = UtilityGetPriceParamsGeneric | UtilityGetPriceParamsPDP;

type UtilityGetPriceParamsGeneric = {
  pdpPage?: never;
  room: TRoom;
  commercialConditions?: CommercialConditions;
  availability?: RoomAvailability;
};

type UtilityGetPriceParamsPDP = {
  pdpPage: true;
  room?: never;
  commercialConditions?: never;
  availability?: RoomAvailability;
};

/**
 * Notes about pdpPage parameter:
 * Added this as a patch, since we do not want to use the data
 * from the room object in the pdp page.
 * If pdpPage is true, the availability object il mandatory,
 * so the statements if (pdpPage) should never be reached.
 * They are just a safety net, and they return "default" values
 * in hope to catch eventual bugs.
 * */
